/*SYSTEM IMPORTS*/
import React from 'react'

import './style'
import './media'

import Img from "components/Img";

/*Ui*/
import Cont from 'components/ui/Cont'
import AwardItem from 'components/ui/AwardItem'


/*Images*/

const ContAwards = ({id, value: { title = "", description = "" }}) => (
    <Cont id={`block-${id}`} className="cont-awards">
        <AwardItem
            title={title}
        >
            {description}
        </AwardItem>
    </Cont>
)

export default ContAwards